var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinterestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 33,
    width: 33,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pinterest") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 33a16 16 0 1116-16 16 16 0 01-16 16z",
    fill: "#ffc212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7 22.24a5.11 5.11 0 01-2.5-1.19 12.59 12.59 0 01-2 5.47.55.55 0 01-1-.32c-.17-3.32 1-5.95 1.54-8.73-1.07-1.8.13-5.43 2.38-4.53 2.78 1.1-2.4 6.69 1.08 7.39s5.11-6.3 2.86-8.58c-3.26-3.31-9.47-.08-8.71 4.65.15.89.9 1.31.8 2.19a.79.79 0 01-1.13.64c-1.44-.67-1.88-2.15-1.81-4a7 7 0 016.32-6.44c3.92-.44 7.6 1.44 8.11 5.13.57 4.17-1.77 8.67-6 8.35z",
    fill: "#28414b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterestIcon);
export default __webpack_public_path__ + "static/media/pinterest_icon.dbf64d72e8532af97d6f42e082546986.svg";
export { ForwardRef as ReactComponent };